/**
 * Session storage key for the URL to return to after login when accessing a protected route.
 */
export const PROTECTED_ROUTE_RETURN_KEY = 'protected_route_return';

export function setProtectedRouteReturn(path: string): void {
  try {
    sessionStorage.setItem(PROTECTED_ROUTE_RETURN_KEY, path);
  } catch {
    // ignore
  }
}

export function getProtectedRouteReturn(): string | null {
  try {
    return sessionStorage.getItem(PROTECTED_ROUTE_RETURN_KEY);
  } catch {
    return null;
  }
}

export function clearProtectedRouteReturn(): void {
  try {
    sessionStorage.removeItem(PROTECTED_ROUTE_RETURN_KEY);
  } catch {
    // ignore
  }
}
